export default __webpack_public_path__ + "static/media/icon-collection.afd2b918.svg";